import Geofence from './src/geofence-combined';
export default Geofence;